package com.example.positionahead.domain

import com.example.positionahead.model.PortfolioSummary
import com.example.positionahead.model.PositionSnapshot
import com.example.positionahead.model.SymbolPerformance

object PerformanceCalculator {

    fun applyPerformance(
        summary: PortfolioSummary,
        performanceBySymbol: Map<String, SymbolPerformance>,
    ): PortfolioSummary {
        val positions = summary.positions.map { snapshot ->
            applyToSnapshot(snapshot, performanceBySymbol[snapshot.position.symbol.uppercase()])
        }
        val portfolio1M = weightedReturn(positions) { it.return1MonthPercent }
        val portfolioYtd = weightedReturn(positions) { it.returnYtdPercent }
        return summary.copy(
            positions = positions,
            return1MonthPercent = portfolio1M,
            returnYtdPercent = portfolioYtd,
        )
    }

    fun applyToSnapshot(
        snapshot: PositionSnapshot,
        performance: SymbolPerformance?,
    ): PositionSnapshot = snapshot.copy(
        return1MonthPercent = performance?.return1MonthPercent,
        returnYtdPercent = performance?.returnYtdPercent,
    )

    fun returnPercent(currentPrice: Double, pastPrice: Double): Double? {
        if (currentPrice <= 0 || pastPrice <= 0) return null
        return ((currentPrice - pastPrice) / pastPrice) * 100.0
    }

    fun mockPerformance(symbol: String): SymbolPerformance {
        val hash = kotlin.math.abs(symbol.hashCode())
        val oneMonth = 1.5 + (hash % 45) / 10.0
        val ytd = 4.0 + (hash % 90) / 10.0
        return SymbolPerformance(return1MonthPercent = oneMonth, returnYtdPercent = ytd)
    }

    private fun weightedReturn(
        positions: List<PositionSnapshot>,
        selector: (PositionSnapshot) -> Double?,
    ): Double? {
        val weighted = positions.mapNotNull { snapshot ->
            val value = selector(snapshot) ?: return@mapNotNull null
            if (snapshot.marketValue <= 0) return@mapNotNull null
            snapshot.marketValue to value
        }
        if (weighted.isEmpty()) return null
        val total = weighted.sumOf { it.first }
        return weighted.sumOf { (value, percent) -> value * percent } / total
    }
}
